import React from 'react';
import { Card, Row, Col, Statistic, Typography } from 'antd';
import { UserOutlined, ClockCircleOutlined, RobotOutlined, FileOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import { formatDuration } from '../utils/formatUtils';

const { Title } = Typography;



const Dashboard = () => {
  const { user } = useAuth();

  return (
    <div>
      <Title level={2}>欢迎使用同方教育大模型应用平台</Title>
      <Title level={4} style={{ marginTop: 0, color: '#666' }}>
        您好，{user?.fullname || user?.username}
      </Title>

      <Row gutter={16} style={{ marginTop: 24 }}>
        <Col span={6}>
          <Card>
            <Statistic
              title="用户组"
              value={user?.user_group === 'admin' ? '管理员' : '普通用户'}
              prefix={<UserOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="上次登录时间"
              value={user?.last_login ? new Date(user.last_login).toLocaleString() : '首次登录'}
              prefix={<ClockCircleOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="大模型使用量"
              value={user?.token_usage || 0}
              precision={0}
              suffix="Tokens"
              prefix={<RobotOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="文本解析量"
              value={user?.page_usage || 0}
              suffix="页"
              prefix={<FileOutlined />}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={16} style={{ marginTop: 16 }}>
        <Col span={6}>
          <Card>
            <Statistic
              title="网课审核时长"
              value={formatDuration(user?.video_audit_duration || 0)}
              prefix={<VideoCameraOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="下载接口使用时长"
              value={formatDuration(user?.plaso_api_duration || 0)}
              prefix={<ClockCircleOutlined />}
            />
          </Card>
        </Col>
      </Row>

      <Card style={{ marginTop: 24 }}>
        <Title level={4}>系统说明</Title>
        <p>本系统是同方教育内部AI工具合集的集中管理系统，提供以下功能：</p>
        <ul>
          <li>管理员功能：新增账户、删除账户、修改用户信息、重置密码</li>
          <li>文档解析功能：支持PDF扫描版文档的内容格式化提取与在线编辑</li>
          <li>题答匹配功能（开发中）：支持将用户上传或扫描出来的题目和答案按照题库格式进行规范化整理</li>
          <li>题库管理功能（开发中）：支持对各类题型题库进行新增、删除、编辑、导入、导出等</li>
          <li>知识管理功能：支持结构化知识库的构建、新增、删除、编辑、导入、导出等，作为题库系统的基础数据</li>
          <li>网课审核功能：支持对上传或者线上网课存档的视频进行快速内容检查</li>
          <li>网课存档功能：支持对线上网课进行视频化存档，并提供下载、预览、整理功能</li>
          <li>模拟直播功能：支持将MP4视频文件推流至伯索平台，实现视频虚拟直播</li>
          <li>成本信息统计：
            <ul>
              <li>大模型使用量：记录使用AI模型的token消耗量</li>
              <li>文本解析量：记录使用文档识别功能的页数</li>
              <li>网课审核时长：记录使用网课审核功能的时长</li>
            </ul>
          </li>
        </ul>
      </Card>
    </div>
  );
};

export default Dashboard; 